import { FC } from 'react'
import {
  Box,
  Button,
  Dialog,
  Divider,
  H3,
  Icon,
  makeStyles,
  Typography,
} from '@perk-ui/core'
import { X } from 'react-feather'

import PatientFlowUrls from '../pages/PatientFlow/PatientFlowUrls'
import PatientSelfOnboardUrls from '../pages/PatientSelfOnboarding/PatientSelfOnboardUrls'
import { useHistory } from '../utils/useHistory'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        maxWidth: '400px',
        width: '100%',
        borderRadius: '12px',
      },
    },
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  closeButton: {
    minWidth: 'auto',
    padding: theme.spacing(0.5),
  },
  divider: {
    marginBottom: theme.spacing(3),
  },
  description: {
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  careFlowButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  standardButton: {
    borderColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
    '&:hover': {
      borderColor: theme.palette.grey[400],
      backgroundColor: theme.palette.grey[50],
    },
  },
}))

interface EnrollmentTypeModalProps {
  open: boolean
  onClose: () => void
  organizationName: string
}

const EnrollmentTypeModal: FC<EnrollmentTypeModalProps> = ({
  open,
  onClose,
  organizationName,
}) => {
  const classes = useStyles()
  const { push } = useHistory()

  const handleCareFlowClick = () => {
    onClose()
    // Open care flow in new tab
    window.open(PatientSelfOnboardUrls.newPatient.create(), '_blank')
  }

  const handleStandardClick = () => {
    onClose()
    push(PatientFlowUrls.invitePatient.create())
  }

  return (
    <Dialog open={open} onClose={onClose} className={classes.root}>
      <Box p={4}>
        <div className={classes.titleRow}>
          <H3>Select Enrollment Type</H3>
          <Button
            size="small"
            variant="text"
            onClick={onClose}
            className={classes.closeButton}
          >
            <Icon size="medium" color="secondaryText">
              <X />
            </Icon>
          </Button>
        </div>
        <Divider className={classes.divider} />

        <Typography className={classes.description}>
          Choose how you&apos;d like to enroll this patient.
        </Typography>

        <div className={classes.buttonContainer}>
          <Button
            fullWidth
            size="large"
            variant="contained"
            className={classes.careFlowButton}
            onClick={handleCareFlowClick}
          >
            {organizationName} Care Flow
          </Button>

          <Button
            fullWidth
            size="large"
            variant="outlined"
            className={classes.standardButton}
            onClick={handleStandardClick}
          >
            Standard Enrollment
          </Button>
        </div>
      </Box>
    </Dialog>
  )
}

export default EnrollmentTypeModal
